import { MediaDevices } from '@wix/package-picker-common';
import * as React from 'react';
import Icon14DaysSmall from '../../../assets/images/page-footer/14-days-icon-small.svg';
import Icon14Days from '../../../assets/images/page-footer/14-days-icon.svg';
import IconCredit from '../../../assets/images/page-footer/get-credit-icon.svg';
import { useIsMobile } from '../../../hooks';
import { useBreakpoint, useComponentsTranslations } from '../../../providers';
import { SidedIconTrustBuilder } from '../SidedIconTrustBuilder';
import { getContentByScenario } from './getContentByScenario';
export const MoneyBackGuarantee = ({ isSecondUpgrade, packagePickerType, }) => {
    const { descKey, titleKey } = getContentByScenario({ isSecondUpgrade, packagePickerType });
    const { t } = useComponentsTranslations();
    const isMobile = useIsMobile();
    const { currentBreakpoint } = useBreakpoint();
    const Icon = () => isSecondUpgrade ? (React.createElement(IconCredit, null)) : isMobile ? (React.createElement(Icon14DaysSmall, null)) : (React.createElement(Icon14Days, null));
    return (React.createElement(SidedIconTrustBuilder, { title: t(titleKey[currentBreakpoint ?? MediaDevices.Desktop]), description: t(descKey), icon: React.createElement(Icon, null) }));
};
//# sourceMappingURL=MoneyBackGuarantee.js.map